export function setKind(kind) {
  return {
    type: 'SET_KIND',
    payload: kind
  }
}

export function setMake(make) {
  return {
    type: 'SET_MAKE',
    payload: make
  }
}

export function setOrder(order) {
  return {
    type: 'SET_ORDER',
    payload: order
  }
}

export function setPageSize(size) {
  return {
    type: 'SET_PAGESIZE',
    payload: size
  }
}

export function setQuery(query) {
  return {
    type: 'SET_QUERY',
    payload: query
  }
}
